export const typeOfAlertIdNotFoundDialog = 'typeOfAlertIdNotFoundDialog';
